import CMSPageLayout from '../../components/CMSPageLayout';

const TermsAndConditions = () => {
  return <CMSPageLayout contentName="TERMNS_AND_CONDITIONS_PAGE_TYPEID"></CMSPageLayout>;
};

export default TermsAndConditions;
